import React from 'react'
import BitesDetailSection from '../components/Details/BiteDetailSection'
import NavBar from '../components/Navbar/NavBar'
import Footer from '../components/Footer/Footer'

function BitesDetail() {
  return (
    <div>
        <NavBar/>
        <BitesDetailSection/>
        <Footer/>

    </div>
  )
}

export default BitesDetail